<template>
  <div id="apiSettings">
    <v-layout wrap class="pr-4 pl-4 mt-4">
      <v-flex xs12 class="button-container pr-0 text-xs-right">
        <div class="d-inline-flex" v-if="selectedData">
          <v-btn class="pf-btn pf-btn-cancel" @click="reset">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-form ref="apiForm">
      <p class="mx-4 pf-text-default">Application username and password to access the Rest API</p>
      <v-layout wrap class="pr-4 pl-4 flex-column">
        <v-flex class="xs12 sm6">
          <v-text-field
            label="API URL"
            hint="Ex: https://example.com/api/, http://example.com/api/"
            persistent-hint
            v-model="apiSettings.url"
            :rules="websiteRules"
            :class="{'pr-4': $vuetify.breakpoint.smAndUp}"
            @input="changedData">
          </v-text-field>
        </v-flex>
        <v-flex class="xs12 sm6">
          <v-text-field label="Application Username" v-model="apiSettings.username" class="required" :rules="[v => !!v || 'Username is required']" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" @input="changedData"></v-text-field>
        </v-flex>
        <v-flex class="xs12 sm6">
          <v-text-field label="Application Password" v-model="apiSettings.password" class="required" :rules="[v => !!v || 'Password is required']" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" @input="changedData" :append-icon="showPassword ? 'visibility' : 'visibility_off'" :type="showPassword ? 'text' : 'password'" counter @click:append="showPassword = !showPassword"></v-text-field>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout wrap class="pr-4 pl-4 mt-4">
      <v-flex xs12 class="button-container pr-0 text-xs-right">
        <div class="d-inline-flex" v-if="selectedData">
          <v-btn class="pf-btn pf-btn-cancel" @click="reset">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
/* global session store  */
import swal from 'sweetalert2';
// import { mapGetters } from 'vuex';
import { update, validateUrl } from '../../helpers/helpers';

export default {
  name: 'rest-api',
  // components: {
  // },
  data: () => ({
    apiSettings: {
      url: '',
      username: '',
      password: ''
    },
    selectedData: false,
    settingsBackup: null,
    showPassword: false,
    websiteRules: [
      (v) => v === undefined || v === '' || (validateUrl(v)) || 'Please enter a valid URL'
    ]
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    }
  },
  async created () {
    if (this.Agency && this.Agency.api_settings && Object.keys(this.Agency.api_settings).length) {
      this.apiSettings = this.Agency.api_settings;
    }

    this.settingsBackup = JSON.parse(JSON.stringify(this.apiSettings));
  },
  methods: {
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      this.selectedData = false;
    },
    reset () {
      this.apiSettings = JSON.parse(JSON.stringify(this.settingsBackup));
      this.hideButtons();
    },
    async save () {
      if (this.selectedData && this.$refs.apiForm.validate()) {
        this.selectedData = false;
        let updatePayload = JSON.parse(JSON.stringify(this.Agency));

        if (Object.keys(this.apiSettings).length) {
          updatePayload.api_settings = this.apiSettings;
          updatePayload.updated_from = 'basic'; // basic will just update the data, wont process the related jobs
          
          let { error, data, status } = await update('Agency', updatePayload, updatePayload.id);
          if (error) {
            this.selectedData = true;
            console.log('error', error);
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Failed to update the data'
            };
          } else {
            /* Update the state */
            this.Agency.api_settings = this.apiSettings;
            swal.fire({
              type: 'success',
              title: 'Data updated successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                this.hideButtons();
              }
            });
          }
        }
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Settings/api.vue